import React from 'react';
import '@/App.css';
import { BrowserRouter, HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './i18n/LanguageContext';
import { AuthProvider, useAuth } from './auth/AuthContext';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import PresentationPage from './pages/PresentationPage';
import AdminPage from './pages/AdminPage';
import PdfPage from './pages/PdfPage';

function LoadingScreen() {
  return (
    <div className="auth-loading" data-testid="auth-loading">
      <div className="auth-loading-mark">◆</div>
      <div className="auth-loading-text">STIG GROUP</div>
    </div>
  );
}

function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (!user || !user.id) return <Navigate to="/login" replace />;
  return children;
}

const STANDALONE = process.env.REACT_APP_STANDALONE === 'true';
// Offline-Bundle (per Doppelklick via file://) braucht Hash-Routing —
// BrowserRouter setzt einen Server voraus und bricht unter file:// ab.
const Router = STANDALONE ? HashRouter : BrowserRouter;

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return <LoadingScreen />;
  if (STANDALONE) return <Navigate to="/present" replace />;
  if (!user || !user.id) return <Navigate to="/login" replace />;
  return <Navigate to="/dashboard" replace />;
}

export default function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/pdf" element={<PdfPage />} />
            <Route path="/dashboard" element={STANDALONE ? <Navigate to="/present" replace /> : <RequireAuth><DashboardPage /></RequireAuth>} />
            <Route path="/present" element={<RequireAuth><PresentationPage /></RequireAuth>} />
            <Route path="/admin" element={<RequireAuth><AdminPage /></RequireAuth>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </LanguageProvider>
  );
}
